import React from "react";
import { Train, Github, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-panel-border bg-ink/60">
      <div className="max-w-[1400px] mx-auto px-6 py-10 grid md:grid-cols-3 gap-6 text-sm">
        <div>
          <div className="flex items-center gap-2 mb-3">
            <span className="inline-flex h-8 w-8 items-center justify-center bg-gold text-ink rounded-sm">
              <Train className="h-4 w-4" />
            </span>
            <span className="font-display tracking-[0.18em] text-cream">INTERQUEST</span>
          </div>
          <p className="text-cream-dim font-serif italic leading-relaxed">
            The one true hub for interrail travel. Plan, dream, ride.
          </p>
        </div>
        <div>
          <div className="iq-overline mb-3">Disclaimers</div>
          <p className="text-cream-dim/80 text-xs leading-relaxed">
            Live times via the open Transitous routing engine. Times shown are scheduled; check operator for real-time updates.
            Prices are <em className="text-cream">indicative</em> — booking & ticket issuance arrive in the next release.
          </p>
        </div>
        <div>
          <div className="iq-overline mb-3">Coordinates</div>
          <div className="flex items-center gap-3 text-cream-dim">
            <a href="mailto:hello@interquest.app" className="hover:text-gold inline-flex items-center gap-2"><Mail className="h-4 w-4" /> hello@interquest.app</a>
          </div>
          <div className="flex items-center gap-3 text-cream-dim mt-2">
            <a href="https://github.com/public-transport/transitous" target="_blank" rel="noreferrer" className="hover:text-gold inline-flex items-center gap-2"><Github className="h-4 w-4" /> Powered by Transitous</a>
          </div>
        </div>
      </div>
      <div className="border-t border-panel-border py-4 text-center text-xs text-cream-dim/60 space-y-1">
        <p>
          Some outbound links to Trainline, Booking.com, Hostelworld, GetYourGuide and Interrail
          earn us a small commission at no extra cost to you. We only feature stays, tickets and
          experiences we'd recommend to a friend.
        </p>
        <p>© {new Date().getFullYear()} InterQuest · A romantic atlas for rail wanderers</p>
      </div>
    </footer>
  );
}
